// "data.<key>" 로 부르는 문구. 값에 {name} 을 두면 t(key, { name }) 로 채운다.
// 작물분석(조회) 탭: 기간 툴바 · 병해충 회차 목록 · 데모 진단 패널 · 차트 공용 문구.
const plural = (n, one, many) => (Number(n) === 1 ? one : many);

const data = {
  ko: {
    "section.pest": "병해충",
    "section.energy": "에너지",

    // 조회 기간 툴바
    "range.label": "조회 기간",
    "range.presetDays": (p) => `${p.days}일`,
    "range.custom": "직접",
    "range.today": "오늘",
    "range.lastDays": (p) => `최근 ${p.days}일`,
    "range.asOf": "{time} 기준",
    "range.refresh": "새로고침",

    // 기간 선택 모달
    "dateModal.close": "닫기",
    "dateModal.cancel": "취소",
    "dateModal.apply": "적용",

    // 회차 등급
    "grade.high": "심각",
    "grade.mid": "주의",
    "grade.ok": "정상",
    "grade.unscanned": "미촬영",

    // 병해충 회차 목록
    "runs.loading": "병해충 데이터를 불러오는 중입니다.",
    "runs.loadError": "병해충 데이터를 불러오지 못했습니다.",
    "runs.empty.noResults": (p) => `완료된 미션 ${p.count}번이 있었지만 진단 결과가 없습니다.`,
    "runs.empty.noResultsHint": "사진이 안 올라왔거나 분석 결과가 아직 안 들어왔습니다.",
    "runs.empty.noCompleted": "이 기간에 촬영을 마친 미션이 없습니다.",
    "runs.empty.abortedCount": (p) => `시작만 하고 끝나지 않은 미션이 ${p.count}번 있습니다.`,
    "runs.empty.noRecords": "이 기간에 촬영한 기록이 없습니다.",
    "runs.empty.noRecordsHint": "기간을 늘리거나 미션을 실행하세요.",
    "runs.count": (p) => `촬영 회차 ${p.count}번`,
    "runs.totalCells": (p) => `밭 전체 ${p.count}칸`,
    "runs.removeFromMap": "지도에서 내리기",
    "runs.showOnMap": "이 회차를 지도에서 보기",
    "runs.onMapBadge": "지도",
    "runs.altitude": (p) => `고도 ${p.value}m`,
    "runs.scanned": (p) => `촬영 ${p.count}칸`,
    "runs.cells": (p) => `${p.count}칸`,
    "runs.table.caption": "한 칸에 병이 여럿이면 각각 셉니다. 더하면 칸 수와 맞지 않습니다.",
    "runs.table.disease": "병해",
    "runs.table.images": "장",
    "runs.table.none": "이상 없음",
    "runs.neverScanned": "이 기간에 한 번도 촬영하지 않은 칸",
    "runs.note.emptyRuns": (p) => `진단 결과가 없는 회차 ${p.count}번`,
    "runs.note.aborted": (p) => `끝나지 않은 미션 ${p.count}번`,
    "runs.note.excluded": "{items}은 목록에서 뺐습니다.",

    // 진단 항목 드롭다운 / 차트 선택
    "select.placeholder": "항목 선택",
    "chartSelect.placeholder": "항목 선택",
    "chartSelect.selectedCount": (p) => `${p.count}개 선택됨`,

    // 추세 그래프
    "trend.unit.confidence": "신뢰도",
    "trend.chipsAria": "표시할 진단 항목",
    "trend.maxVisible": (p) => `한 번에 ${p.max}개까지 표시합니다`,
    "trend.noOptions": "선택 가능한 진단 항목이 없습니다.",
    "trend.loading": "추세 데이터를 불러오는 중입니다.",
    "trend.empty": "선택한 기간에 표시할 데이터가 없습니다.",

    // 진단 비율
    "ratio.title": "진단 비율",
    "ratio.loading": "진단 데이터를 불러오는 중입니다.",
    "ratio.loadError": "진단 데이터를 불러오지 못했습니다.",
    "ratio.empty": "표시할 진단 데이터가 없습니다.",

    // 툴팁 단위(병해충 건수)
    "unit.count": "건",

    // 데모 진단 패널
    "demo.item.sclerotinia": "양배추균핵병",
    "demo.item.softRot": "양배추무름병",
    "demo.item.cabbageWhite": "배추흰나비",
    "demo.item.fleaBeetle": "벼룩잎벌레",
    "demo.item.normal": "정상",
    "demo.summary.items": "진단 항목",
    "demo.summary.itemCount": (p) => `${p.count}종`,
    "demo.summary.top": "주요 진단",
    "demo.summary.risk": "위험도",
    "demo.risk.high": "높음",
    "demo.risk.low": "낮음",
    "demo.summary.latest": "최근 진단",
    "demo.summary.latestDate": (p) => `${p.month}월 ${p.day}일`,
    "demo.trendTitle": "진단 그래프",
    "demo.rangeAria": "조회 기간: {range}",
    "demo.select.first": "첫 번째 진단 항목",
    "demo.select.second": "두 번째 진단 항목",
    "demo.unit.count": "건수",
  },
  en: {
    "section.pest": "Disease & Pest",
    "section.energy": "Energy",

    "range.label": "Date range",
    "range.presetDays": (p) => `${p.days}D`,
    "range.custom": "Custom",
    "range.today": "Today",
    "range.lastDays": (p) => `Last ${p.days} days`,
    "range.asOf": "as of {time}",
    "range.refresh": "Refresh",

    "dateModal.close": "Close",
    "dateModal.cancel": "Cancel",
    "dateModal.apply": "Apply",

    "grade.high": "Severe",
    "grade.mid": "Warning",
    "grade.ok": "Normal",
    "grade.unscanned": "Not scanned",

    "runs.loading": "Loading disease and pest data...",
    "runs.loadError": "Failed to load disease and pest data.",
    "runs.empty.noResults": (p) =>
      `${p.count} completed ${plural(p.count, "mission", "missions")}, but no diagnosis results.`,
    "runs.empty.noResultsHint": "Photos were not uploaded or analysis results have not arrived yet.",
    "runs.empty.noCompleted": "No mission finished scanning in this period.",
    "runs.empty.abortedCount": (p) =>
      `${p.count} ${plural(p.count, "mission", "missions")} started but did not finish.`,
    "runs.empty.noRecords": "No scan records in this period.",
    "runs.empty.noRecordsHint": "Extend the period or run a mission.",
    "runs.count": (p) => `${p.count} scan ${plural(p.count, "run", "runs")}`,
    "runs.totalCells": (p) => `${p.count} ${plural(p.count, "cell", "cells")} in field`,
    "runs.removeFromMap": "Remove from map",
    "runs.showOnMap": "Show this run on the map",
    "runs.onMapBadge": "Map",
    "runs.altitude": (p) => `Alt ${p.value}m`,
    "runs.scanned": (p) => `${p.count} scanned`,
    "runs.cells": (p) => `${p.count} ${plural(p.count, "cell", "cells")}`,
    "runs.table.caption":
      "A cell with several diseases is counted once per disease, so the sum may not match the cell count.",
    "runs.table.disease": "Disease",
    "runs.table.images": "Images",
    "runs.table.none": "No issues",
    "runs.neverScanned": "Cells never scanned in this period",
    "runs.note.emptyRuns": (p) => `${p.count} ${plural(p.count, "run", "runs")} without results`,
    "runs.note.aborted": (p) => `${p.count} unfinished ${plural(p.count, "mission", "missions")}`,
    "runs.note.excluded": "Excluded from the list: {items}.",

    "select.placeholder": "Select an item",
    "chartSelect.placeholder": "Select Options",
    "chartSelect.selectedCount": (p) => `${p.count} selected`,

    "trend.unit.confidence": "Confidence",
    "trend.chipsAria": "Diagnosis items to display",
    "trend.maxVisible": (p) => `Up to ${p.max} items at a time`,
    "trend.noOptions": "No diagnosis items available.",
    "trend.loading": "Loading trend data...",
    "trend.empty": "No data to display for the selected period.",

    "ratio.title": "Diagnosis ratio",
    "ratio.loading": "Loading diagnosis data...",
    "ratio.loadError": "Failed to load diagnosis data.",
    "ratio.empty": "No diagnosis data to display.",

    "unit.count": (p) => plural(p.count, "count", "counts"),

    "demo.item.sclerotinia": "Sclerotinia rot",
    "demo.item.softRot": "Soft rot",
    "demo.item.cabbageWhite": "Cabbage white butterfly",
    "demo.item.fleaBeetle": "Flea beetle",
    "demo.item.normal": "Normal",
    "demo.summary.items": "Diagnosed items",
    "demo.summary.itemCount": (p) => `${p.count} ${plural(p.count, "type", "types")}`,
    "demo.summary.top": "Top diagnosis",
    "demo.summary.risk": "Risk level",
    "demo.risk.high": "High",
    "demo.risk.low": "Low",
    "demo.summary.latest": "Latest diagnosis",
    "demo.summary.latestDate": (p) => `${p.month}/${p.day}`,
    "demo.trendTitle": "Diagnosis trend",
    "demo.rangeAria": "Date range: {range}",
    "demo.select.first": "First diagnosis item",
    "demo.select.second": "Second diagnosis item",
    "demo.unit.count": "Count",
  },
};

export default data;
